import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Register from '@/components/Register'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import Profile from '@/components/Profile'
import ManageCards from '@/components/ManageCards'
import LinkCard from '@/components/LinkCard'
import UnlinkCard from '@/components/UnlinkCard'
import Offers from '@/components/Offers'
import OffersInProgress from '@/components/OffersInProgress'
import OfferDetail from '@/components/OfferDetail'
import RedeemedRewards from '@/components/RedeemedRewards'
import NotFound from '@/components/NotFound'
import authenticated from '@/middleware/Authenticated'
import ExcentusAPIService from '@/services/ExcentusAPIService'
import SessionStorageService from '@/services/SessionStorageService'
import injector from 'vue-inject'

Vue.use(Router)
Vue.use(injector)

injector.service('apiService', ExcentusAPIService)
injector.service('storageService', SessionStorageService)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                middleware: authenticated
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/forgot_password',
            name: 'ForgotPassword',
            component: ForgotPassword,
            meta: {
                displayName: 'Forgot Password'
            }
        },
        {
            path: '/reset_password/:userId',
            name: 'ResetPassword',
            component: ResetPassword,
            meta: {
                displayName: 'Reset Password'
            }
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            meta: {
                middleware: authenticated
            }
        },
        {
            path: '/cards',
            name: 'ManageCards',
            component: ManageCards,
            meta: {
                middleware: authenticated,
                displayName: 'Manage Cards'
            }
        },
        {
            path: '/cards/link',
            name: 'LinkCard',
            component: LinkCard,
            meta: {
                middleware: authenticated,
                displayName: 'Link Card'
            }
        },
        {
            path: '/cards/unlink/:cardNumber',
            name: 'UnlinkCard',
            component: UnlinkCard,
            meta: {
                middleware: authenticated,
                displayName: 'Unlink Card'
            }
        },
        {
            path: '/deals',
            name: 'Offers',
            component: Offers,
            meta: {
                middleware: authenticated
            }
        },
        {
            path: '/deals/in-progress',
            name: 'OffersInProgress',
            component: OffersInProgress,
            meta: {
                middleware: authenticated
            }
        },
        {
            path: '/deals/detail/:id',
            name: 'OfferDetail',
            component: OfferDetail,
            meta: {
                middleware: authenticated,
                displayName: 'Offer Detail'
            }
        },
        {
            path: '/redeemed_rewards',
            name: 'RedeemedRewards',
            component: RedeemedRewards,
            meta: {
                middleware: authenticated,
                displayName: 'Redeemed Rewards'
            }
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound,
            meta: {
                displayName: '404 Not Found'
            }
        }
    ]
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory (context, middleware, index) {
    const subsequentMiddleware = middleware[index]
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters)
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1)
        subsequentMiddleware({ ...context, next: nextMiddleware })
    }
}

router.beforeEach((to, from, next) => {
    if (window.parent.updateBreadcrumbs) {
        window.parent.updateBreadcrumbs(to.meta.displayName ? to.meta.displayName : to.name,
            [{ href: to.path, title: to.meta.displayName ? to.meta.displayName : to.name }])
    }

    if (window.parent.history.replaceState) {
        window.parent.history.replaceState(null, to.name, null)
    }

    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware]

        const context = {
            from,
            next,
            router,
            to
        }

        const nextMiddleware = nextFactory(context, middleware, 1)
        return middleware[0]({ ...context, next: nextMiddleware })
    }

    return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js